import po from '../../po';
import { isString } from '../../helper/string';

export const translate = (str, locale) => {
  if (po[locale] && isString(po[locale][str])) {
    return po[locale][str];
  }
  return str;
};
